import { useContext } from 'react';
import ManagementContext from '../context/ManagementContext';

const useManagement = () => useContext(ManagementContext);

export default useManagement;
